import { render, staticRenderFns } from "./ManualOrderView.vue?vue&type=template&id=18344bff"
import script from "./ManualOrderView.vue?vue&type=script&lang=js"
export * from "./ManualOrderView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports